import { useState } from 'react'
import { BLOG_CONTENT_API } from '@/constants'
import { IGhostData } from '@/types/ghostData.interface'
import { replaceString } from '@/utils/replaceString'

export const useBlogCms = () => {
  const [loading, setLoading] = useState(true)
  const [compassContent, setList] = useState<IGhostData>({
    posts: [],
    pages: [],
  })

  const resource = (path: string) => {
    return replaceString(BLOG_CONTENT_API, {
      key: 'resource',
      value: path,
    })
  }

  const getContent = async (
    {
      path,
      params,
    }: {
      path: string
      params?: string
    },
    abortController?: AbortController
  ) => {
    setLoading(true)
    try {
      const res = await fetch(`${resource(path)}${params ?? ''}`, {
        signal: abortController?.signal,
      })
      const content = await res.json()

      // Ghost Content API returns either { posts: [...] } or { pages: [...] }
      // Merge whichever is returned while keeping the other intact
      setList((prev) => ({
        ...prev,
        ...content,
      }))
      setLoading(false)
    } catch (e) {
      setList({ posts: [], pages: [] })
      setLoading(false)
    }
  }

  const getPosts = (abortController?: AbortController) =>
    getContent({ path: 'posts', params: '' }, abortController)

  const getPages = (abortController?: AbortController) =>
    getContent({ path: 'pages', params: '' }, abortController)

  return { compassContent, getContent, getPosts, getPages, loading }
}
